import { styled } from '@mui/material/styles';

export const HeaderContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  marginTop: '24px',

  '& button': {
    marginTop: '0',
    flex: '0 0 auto',
  },

  '& .address-lookup': {
    flex: '1 1 auto',
    minWidth: 0,
  },
});
